/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EVMChain = {
    ETHEREUM_MAINNET: 'ETHEREUM_MAINNET',
    POLYGON: 'POLYGON',
    AVALANCHE: 'AVALANCHE',
    MUMBAI: 'MUMBAI',
    BASE: 'BASE',
    SOLANA: 'SOLANA'
} as const;
export type EVMChain = typeof EVMChain[keyof typeof EVMChain];


export function instanceOfEVMChain(value: any): boolean {
    for (const key in EVMChain) {
        if (Object.prototype.hasOwnProperty.call(EVMChain, key)) {
            if (EVMChain[key as keyof typeof EVMChain] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EVMChainFromJSON(json: any): EVMChain {
    return EVMChainFromJSONTyped(json, false);
}

export function EVMChainFromJSONTyped(json: any, ignoreDiscriminator: boolean): EVMChain {
    return json as EVMChain;
}

export function EVMChainToJSON(value?: EVMChain | null): any {
    return value as any;
}

export function EVMChainToJSONTyped(value: any, ignoreDiscriminator: boolean): EVMChain {
    return value as EVMChain;
}

